import { Typography } from '@material-ui/core';
import styled from '@emotion/styled';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';
import theme from '../../../theme';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import Spinner from '../compound/Spinner';

type Props = {
  visible?: boolean;
  loadingMessage?: string;
  className?: string;
};

const ModalSpinner: FC<Props> = ({ visible = false, loadingMessage = '', className }) => (
  <Root visible={visible} className={className}>
    <Spinner width="64px" height="64px" />
    {loadingMessage && (
      <LoadingMessage variant="body1">
        <FormattedMessage id={loadingMessage} />
      </LoadingMessage>
    )}
  </Root>
);

const backdropColor = 'rgba(0, 0, 0, .75)';

const Root = styled('div')<{ visible: boolean }>(({ visible }) => ({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  backgroundColor: backdropColor,
  opacity: visible ? 1 : 0,
  visibility: visible ? 'visible' : 'hidden',
  transition: `opacity ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut} 0ms,
               visibility 0ms linear ${visible ? 0 : theme.transitions.duration.standard}ms`,
}));

const LoadingMessage = styled(Typography)({
  color: theme.palette.getContrastText(backdropColor),
}) as typeof Typography;

export default ModalSpinner;
